import { Injectable } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { first, map, Observable } from 'rxjs';
import { AuthState } from '../_state/auth.state';
import { Store } from '@ngxs/store';
import { AuthService } from './auth.service';
@Injectable()
export class AdminGuard {
  constructor(
    private router: Router,
    private store: Store,
    private authService: AuthService
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.store.select(AuthState.fetch()).pipe(
      first(),
      map((loginInfo) => {
        if (
          loginInfo?.isAuthenticated &&
          (loginInfo?.type == 'Admin' || loginInfo?.type == 'Staff')
        ) {
          return true;
        }
        this.authService.logIn();
        return false;
      })
    );
  }
}
